import { Dropdown } from '../../../components/ui';

interface FinancialsStepProps {
  monthlyRevenue: string;
  monthlyExpenses: string;
  onRevenueChange: (revenue: string) => void;
  onExpensesChange: (expenses: string) => void;
}

const REVENUE_OPTIONS = [
  { value: 'under10k', label: 'Under $10,000' },
  { value: '10k-25k', label: '$10,000 - $25,000' },
  { value: '25k-50k', label: '$25,000 - $50,000' },
  { value: '50k-100k', label: '$50,000 - $100,000' },
  { value: '100k-250k', label: '$100,000 - $250,000' },
  { value: 'over250k', label: 'Over $250,000' },
];

const EXPENSES_OPTIONS = [
  { value: 'under5k', label: 'Under $5,000' },
  { value: '5k-10k', label: '$5,000 - $10,000' },
  { value: '10k-25k', label: '$10,000 - $25,000' },
  { value: '25k-50k', label: '$25,000 - $50,000' },
  { value: '50k-100k', label: '$50,000 - $100,000' },
  { value: 'over100k', label: 'Over $100,000' },
];

export default function FinancialsStep({
  monthlyRevenue,
  monthlyExpenses,
  onRevenueChange,
  onExpensesChange,
}: FinancialsStepProps) {
  return (
    <div className="quiz-step">
      <div className="quiz-step__header">
        <h2 className="quiz-step__question">What are your monthly numbers?</h2>
        <p className="quiz-step__helper">We'll use these to calculate exactly what you can save and invest</p>
      </div>

      <div className="quiz-step__body">
        <Dropdown
          label="Monthly Revenue"
          placeholder="Select revenue range"
          value={monthlyRevenue}
          onChange={onRevenueChange}
          options={REVENUE_OPTIONS}
          size="lg"
        />

        <Dropdown
          label="Monthly Expenses"
          placeholder="Select expenses range"
          value={monthlyExpenses}
          onChange={onExpensesChange}
          options={EXPENSES_OPTIONS}
          size="lg"
        />
      </div>
    </div>
  );
}
